import { Accordion, Icon, Label, Message, Segment } from "semantic-ui-react";
import React from "react";
import ResourceRow from "../ResourceRow";
import styles from "../Resources.module.css"


const DefaultMedicalResourceSlide1 = (textTitle: string) => {  
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Find a Geriatrics Healthcare Professional"
        url="https://www.healthinaging.org/find-geriatrics-healthcare-professional"
        descriptionText="The Health in Aging Foundation tells consumers how to find geriatric health professionals."
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="About a Comprehensive Geriatric Assessment"
        url="https://www.merckmanuals.com/professional/geriatrics/approach-to-the-geriatric-patient/comprehensive-geriatric-assessment"
        descriptionText="The Merck Manual of Geriatrics provides information about what occurs when a physician performs a geriatric assessment."
        />    
    </Segment.Group>  
    </>
  );
};

const DefaultMedicalResourceSlide2 = (textTitle: string) => {  
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="A Guide to Geriatric Syndromes"
        url="https://www.healthinaging.org/sites/default/files/media/pdf/HIA-TipSheet%20Geriatric%20Syndromes19.pdf"
        descriptionText="A pdf that shows different types of Geriatric Syndromes and what should be done about them."
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="Aging & Health A-Z"
        url="https://www.healthinaging.org/aging-health-a-z"
        descriptionText="A Guide for Common Terminology: a list of clickable terms that link you to more information on it."
        />    
      <ResourceRow urlText="Merck Manuals: A Place for Medical Information"
        url="https://www.merckmanuals.com/home"
        descriptionText="A website dedicated to sharing medical information for consumers."
        />
    </Segment.Group>  
    </>
  );
};

const DefaultMedicalResourceSlide3 = (textTitle: string) => {  
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="How to Talk to Your Healthcare Provider"
        url="https://www.healthinaging.org/tools-and-tips/tip-sheet-how-talk-your-healthcare-provider-tips-improving-communication"
        descriptionText="The American Geriatrics Society provides tips about how to make the most of visits with physicians with a focus on improving communication."
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="Action Items on How to Take Charge of Your Health Care"
        url="https://health.gov/myhealthfinder/doctor-visits/talking-doctor/take-charge-your-health-care"
        descriptionText="Health and Human Services provides tips on talking with physicians."
        />    
    </Segment.Group>  
    </>
  );
};

const DefaultMedicalResourceSlide4 = (textTitle: string) => {  
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Safe Use of Medicines"
        url="https://order.nia.nih.gov/sites/default/files/2019-01/Safe-Use-of-Medicines_508.pdf"
        descriptionText="Tips for taking medicines safely as you age."
        groupedHeaderText="All the following provide help with organizing and administering medications"
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="Organizing and Administering Pills"
        url="https://www.aarp.org/content/dam/aarp/ppi/2019/04/organizing-and-administering-pills.pdf"
        descriptionText="If you're not sure about any medication in any way be sure to ask the prescriber, nurse, or pharmacist for help. It is also
          important to organize the medications so they're given on the right day, at the right time, and in the right dose."
        />    
      <ResourceRow urlText="Medication Management for Family Caregivers"
        url="https://www.nextstepincare.org/Caregiver_Home/Medication_Management_Guide"
        descriptionText="This link includes medication management downloadable pdf guides, downloadable pdf forms, and videos. The pdf's are available in multiple languages."
        />
      <ResourceRow urlText="What Older Adults Can Do to Manage Medications"
        url="https://www.healthinaging.org/medications-older-adults/what-older-adults-can-do-manage-medications"
        descriptionText="You can lower your risk of problems with medications by keeping the following tips in mind and ask questions of your healthcare professional or pharmacist."
        />    
    </Segment.Group>  
    </>
  );
};

const DefaultMedicalResourceSlide5 = (textTitle: string) => {  
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Safe Driving Tips for Older Adults"
        url="https://www.nia.nih.gov/health/older-drivers"
        descriptionText="National Institute on Aging provides tips"
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="How Does the Aging Process Affect Driving Ability?"
        url="http://health.howstuffworks.com/life-stages/aging/age-and-driving.htm"
        descriptionText="Breaks down the components of how aging impacts driving and how to recognize driving danger signs and how to determine if they are unsafe."
        />    
      <ResourceRow urlText="Information About Functional Driving Assessments"
        url="https://www.merckmanuals.com/professional/geriatrics/the-older-driver/functional-assessment-of-the-older-driver"
        descriptionText="Merck Manual has a chapter dedicated to Older Drivers. Be sure to check out the other topics in this chapter."
        />
      <ResourceRow urlText="Driving Evaluations for Cognitive Issues"
        url="https://www.uab.edu/medicine/pcp-tbi/pcp-resource-topics/driving/assessing-readiness-to-drive"
        descriptionText="Assessing readiness to drive."
        />    
      <ResourceRow urlText="Senior Driver Safety and Mobility Resource"
        url="https://exchange.aaa.com/safety/senior-driver-safety-mobility/evaluate-your-driving-ability/"
        descriptionText="AAA's Senior Driver Safety and Mobility Resource that includes a self-rating tool."
        />
      <ResourceRow urlText="National Database of Driving Programs and Specialists "
        url="https://myaota.aota.org/driver_search/index.aspx/index.aspx"
        descriptionText="American Occupational Therapy Association (AOTA) tool to search for a Driving Rehabilitation Provider."
        />    
    </Segment.Group>  
    </>
  );
};

const DefaultMedicalResourceSlide6 = (textTitle: string) => {  
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Information About Geriatric Care Managers"
        url="https://www.nia.nih.gov/health/what-geriatric-care-manager"
        descriptionText="National Institute on Aging: discussing what a geriatric care manager is, what they do, and how to find one."
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="Why Hire a Geriatric Care Manager?"
        url="http://newoldage.blogs.nytimes.com/2008/10/06/why-hire-a-geriatric-care-manager"
        descriptionText="The New Old Age by The New York Times discussing the benefits of hiring a geriatric care manager."
        />    
      <ResourceRow urlText="Eldercare Locator: A Tool for Finding Geriatric Services"
        url="https://eldercare.acl.gov/Public/Index.aspx"
        descriptionText="A public service of the U.S. Administration on Aging connecting you to services for older adults and their families."
        />
    </Segment.Group>  
    </>
  );
};

const DefaultMedicalResourceSlide7 = (textTitle: string) => {  
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="How to Select an Assisted Living Facility"
        url="https://theconsumervoice.org/uploads/files/issues/2._How_to_Select_an_Assisted-Living_Facility.pdf"
        descriptionText="A pdf guide from The Consumer Voice on the information needed and the questions to be asked on how to find the best Assisted Living Facility."
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="AARP Article on Choosing a Facility"
        url="https://www.aarp.org/caregiving/basics/info-2017/assisted-living-options.html#:~:text=Your%20local%20or%20state%20Area,find%20the%20nearest%20aging%20agency"
        descriptionText="Assisted Living Facilities: Weighing the Options. What family caregivers need to know about services, costs, and finding the right place."
        />    
      <ResourceRow urlText="How to Research Assisted Living Facilities"
        url="https://health.usnews.com/best-assisted-living/articles/what-is-the-best-way-to-research-assisted-living-facilities"
        descriptionText="Health US News article: What Is the Best Way to Research Assisted Living Facilities? Learn how to locate facilities in your area and what to ask before making a move."
        />
      <ResourceRow urlText="Nursing Care"
        url="https://www.jointcommission.org/-/media/tjc/documents/resources/for-consumers/helping-you-choose-nursing-care.pdf"
        descriptionText="A pdf by The Joint Commission on helping you choose quality nursing care center services."
        groupedHeaderText="Guides for Questions to Ask When Choosing Care and Facilities"
        />    
      <ResourceRow urlText="Ambulatory Care"
        url="https://www.jointcommission.org/-/media/tjc/documents/resources/for-consumers/helping-you-choose-ambulatory.pdf"
        descriptionText="A pdf by The Joint Commission on helping you choose quality ambulatory care."
        />
      <ResourceRow urlText="Hospitals"
        url="https://www.jointcommission.org/-/media/tjc/documents/resources/for-consumers/helping-you-choose-hospital.pdf"
        descriptionText="A pdf by The Joint Commission on helping you choose quality hospital care."
        />
    </Segment.Group>  
    </>
  );
};

const DefaultMedicalResourceSlide8 = (textTitle: string) => {  
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="NIA: Exercise and Older Adults Toolkit"
        url="https://www.nia.nih.gov/exercise-toolkit"
        descriptionText="National Institute on Aging page that provides: information articles, research news, infographics, publications, and videos."
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="How much physical activity do older adults need?"
        url="https://www.cdc.gov/physicalactivity/basics/older_adults/index.htm"
        descriptionText="Article by CDC discussing why physical activity is important with sample weekly schedules."
        />    
      <ResourceRow urlText="The Life-Changing Benefits of Exercise After 60"
        url="https://ncoa.org/article/the-life-changing-benefits-of-exercise-after-60"
        descriptionText="National Council on Aging: benefits of exercise, best forms of exercise, and suggestions for community fitness."
        />
      <ResourceRow urlText="NIA: Exercise and Physical Activity"
        url="https://www.nia.nih.gov/health/topics/exercise-and-physical-activity"
        descriptionText="National Institute on Aging list of articles with tips on how to fit exercise into daily life savely and get motivated to get moving."
        />    
      <ResourceRow urlText="Exercise Plan for Seniors"
        url="https://www.healthline.com/health/everyday-fitness/senior-workouts"
        descriptionText="A sample week schedule and an included 6 minute strength workout."
        groupedHeaderText="Sample Exercise Plans for Seniors"
        />
      <ResourceRow urlText="Balance & Strength"
        url="https://dailycaring.com/video-15-minute-senior-exercise-program-for-balance-and-strength/"
        descriptionText="A 15-minute senior exercise video for balance and strength by DailyCaring."
        /> 
    </Segment.Group>  
    </>
  );
};

const DefaultMedicalResourceSlide9 = (textTitle: string) => {  
  return (
    <>
    <Segment.Group raised className={styles.segmentGroup} >
      <ResourceRow urlText="Assessing Cognitive Impairment in Senior"
        url="https://www.nia.nih.gov/health/assessing-cognitive-impairment-older-patients"
        descriptionText="National Institute on Aging discussing the assessing of cognitive impairment in older patients."
        taskHeaderText={textTitle}
        />    
      <ResourceRow urlText="What to Expect from a Cognitive Assessment"
        url="https://www.alz.org/professionals/health-systems-medical-professionals/cognitive-assessment"
        descriptionText="Alzheimer's Association provides guidance and tools for conducting a cognitive assessment during a time-limited office visit. Detecting possible cognitive impairment is the first step in determining whether or not a patient needs further evaluation."
        />    
      <ResourceRow urlText="Information on Mild Cognitive Impairment (MCI)"
        url="https://www.mayoclinic.org/diseases-conditions/mild-cognitive-impairment/symptoms-causes/syc-20354578#:~:text=You%20find%20it%20hard%20to,notice%20any%20of%20these%20changes"
        descriptionText="Mayo Clinic article on Mild cognitive impairment (MCI) is the stage between the expected decline in memory and thinking that happens with age and the more serious decline of dementia. MCI may include problems with memory, language, or judgment."
        />
      <ResourceRow urlText="CDC Article on Cognitive Impairment"
        url="https://www.cdc.gov/aging/pdf/cognitive_impairment/cogimp_poilicy_final.pdf"
        descriptionText="A pdf guide by the CDC on Cognitive Impairment."
        />    
      <ResourceRow urlText="Fact Sheet for the Detection of Cognitive Impairment"
        url="https://www.prevention.va.gov/docs/NCP_CPS_Factsheet_Cognitive_Impairment.pdf"
        descriptionText="A pdf by the Veteran's Health Administration on Cognitive Impairment detection."
        />
    </Segment.Group>  
    </>
  );
};

const accordionResourceDisplay = (keyVal: string, title: string, slideFunction: any) => {

  const accordions = [
    { key: 'keyVal',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.resourcesAccordionLabelTitleIcon} />, 
        content: <Label className={styles.resourcesAccordionLabelTitle} > {title} </Label> },
      content: { 
        content: (<Message className={styles.resourcesAccordionMessageBox} content={slideFunction()}/>)
      }
    }
  ];

  return (
    <>
      <div className={styles.resourceAccordionWrapper}>
        <Accordion panels={accordions} defaultActiveIndex={0} />
      </div>
    </>
  );
}

const AllResources = () => {
  return (
    <>
      {accordionResourceDisplay('MedicalDomainTask1', 'Geriatric Assessment Resources', () => DefaultMedicalResourceSlide1(""))}
      {accordionResourceDisplay('MedicalDomainTask2', 'Monitoring Changes Resources', () => DefaultMedicalResourceSlide2(""))}
      {accordionResourceDisplay('MedicalDomainTask3', 'Healthcare Team Resources', () => DefaultMedicalResourceSlide3(""))}
      {accordionResourceDisplay('MedicalDomainTask4', 'Medication Management Resources', () => DefaultMedicalResourceSlide4(""))}
      {accordionResourceDisplay('MedicalDomainTask5', 'Evaluate Driving Skills Resources', () => DefaultMedicalResourceSlide5(""))}
      {accordionResourceDisplay('MedicalDomainTask6', 'Plan with Geriatric Care Manager Resources', () => DefaultMedicalResourceSlide6(""))}
      {accordionResourceDisplay('MedicalDomainTask7', 'Assess Facility Quality Resources', () => DefaultMedicalResourceSlide7(""))}
      {accordionResourceDisplay('MedicalDomainTask8', 'Exercise and Activity Plan Resources', () => DefaultMedicalResourceSlide8(""))}
      {accordionResourceDisplay('MedicalDomainTask9', 'Learn About Cognitive Impairment Resources', () => DefaultMedicalResourceSlide9(""))}
    </>
  );
};

const MedicalResourceFactory: React.FC<{
  questionKey: string;
}> = (props) => {
  const { questionKey } = props;
  
  switch( questionKey ){
    case "MedicalDomainTask1":
      return DefaultMedicalResourceSlide1('Geriatric Assessment');
    case "MedicalDomainTask2":
      return DefaultMedicalResourceSlide2('Monitoring Changes');
    case "MedicalDomainTask3":
      return DefaultMedicalResourceSlide3('Healthcare Team');
    case "MedicalDomainTask4":
      return DefaultMedicalResourceSlide4('Medication Management');
    case "MedicalDomainTask5": 
      return DefaultMedicalResourceSlide5('Evaluate Driving Skills');
    case "MedicalDomainTask6":
      return DefaultMedicalResourceSlide6('Plan with Geriatric Care Manager');
    case "MedicalDomainTask7":
      return DefaultMedicalResourceSlide7('Assess Facility Quality');
    case "MedicalDomainTask8":
      return DefaultMedicalResourceSlide8('Exercise and Activity Plan');
    case "MedicalDomainTask9":
      return DefaultMedicalResourceSlide9('Learn About Cognitive Impairment');
    case "":
      return AllResources();
    default:
      return null;
  };
};

export default MedicalResourceFactory;
